module.exports = __webpack_public_path__ + "static/img/z4.6ea5674.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z4.png
// module id = v3NO
// module chunks = 0